import React from 'react';
import {MdTrendingFlat} from 'react-icons/md';
import Button from '@mui/material/Button';
import { Link} from 'react-router-dom';
import { urlFor } from '../../Client';
import { FaGithub } from 'react-icons/fa';
import { AiFillEye } from 'react-icons/ai';


const Card = ({element}) => {
    const {serverLink,clientLink,liveLink} = element; 
    return (
        <div className="container projects absolute z-50" style={{ padding: '5rem 0' }}>
                  <div>
            <div className="card container-fluid px-3" data-aos="flip-right">
                <div className="image">
                    <img src={urlFor(element.coverPic)} alt={element.name} />
                </div>
                <div className="details">
                    <div className="center">
                        <h1>{element.name}s<br /><span>{element.title}</span></h1>
                        <p>{element.slogan}</p>
                        {/* <Button><a href={liveLink} target="_blank"><AiFillEye /> Visit</a></Button>
                        {
                            serverLink ? 
                            <> 
                            <Button ><a href={clientLink} target="_blank"><FaGithub /> Client </a></Button>
                            <Button ><a href={serverLink} target="_blank"><FaGithub /> Server </a></Button>
                            </>
                            :
                            <Button >
                                <a href={clientLink} target="_blank"><FaGithub /> Github </a></Button>               
                          } */}
                        <ul>
                            <li>
                            <Link to={ `/projectDetails/${element._id}`} target="_blank" rel="noopener noreferrer"><Button className='px-5' >CLICK HERE FOR  DETAILS<MdTrendingFlat /></Button></Link>
                            </li>
                        </ul>
            </div>
            </div>
            </div>
            </div>
            </div>
    );
};

export default Card;